/**
 * Helper dùng chung cho Bộ lọc thời gian.
 * Mọi màn hình có bộ lọc thời gian phải import từ đây, không tự tính lại.
 */

// Số ngày mặc định của bộ lọc thời gian (tính cả ngày hôm nay)
export const DEFAULT_FILTER_RANGE_DAYS = 7

/**
 * Lấy ngày cách hôm nay n ngày.
 * otp.type = 'start' => 00:00:00, otp.type = 'end' => 23:59
 */
export const getDateFromNow = (n, otp) => {
  let date = new Date()
  if (otp && otp?.type == 'start') date.setHours(0, 0, 0, 0)
  if (otp && otp?.type == 'end') date.setHours(23, 59, 0, 0)
  const res = date.setTime(date.getTime() + n * 24 * 60 * 60 * 1000)
  return new Date(res)
}

// 00:00:00 của ngày truyền vào
export const toStartOfDay = value => {
  const date = new Date(value)
  if (isNaN(date.getTime())) return value

  date.setHours(0, 0, 0, 0)
  return date
}

// 23:59 của ngày truyền vào
export const toEndOfDay = value => {
  const date = new Date(value)
  if (isNaN(date.getTime())) return value

  date.setHours(23, 59, 0, 0)
  return date
}

// Ngày bắt đầu mặc định: hôm nay - (days - 1), lúc 00:00
export const getDefaultFilterStartDate = (days = DEFAULT_FILTER_RANGE_DAYS) =>
  getDateFromNow(-(days - 1), {type: 'start'})

// Ngày kết thúc mặc định: hôm nay, lúc 23:59
export const getDefaultFilterEndDate = () => getDateFromNow(0, {type: 'end'})

// Khoảng mặc định: [hôm nay - 6 (00:00), hôm nay (23:59)]
export const getDefaultFilterDateRange = (days = DEFAULT_FILTER_RANGE_DAYS) => [
  getDefaultFilterStartDate(days),
  getDefaultFilterEndDate(),
]

// So sánh 2 giá trị có cùng 1 ngày dương lịch hay không (bỏ qua giờ)
export const isSameCalendarDay = (a, b) => {
  if (!a || !b) return false

  const dateA = new Date(a)
  const dateB = new Date(b)
  if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) return false

  return (
    dateA.getFullYear() === dateB.getFullYear() &&
    dateA.getMonth() === dateB.getMonth() &&
    dateA.getDate() === dateB.getDate()
  )
}

/**
 * Khi người dùng chọn lại NGÀY kết thúc => mặc định 23:59 của ngày đó.
 * Nếu chỉ chỉnh GIỜ (vẫn cùng 1 ngày kết thúc) => giữ nguyên giờ user chọn.
 */
export const normalizeDateRangeEndTime = (nextRange, prevRange) => {
  if (!Array.isArray(nextRange) || !nextRange[1]) return nextRange

  const nextEnd = new Date(nextRange[1])
  if (isNaN(nextEnd.getTime())) return nextRange

  const prevEnd = Array.isArray(prevRange) ? prevRange[1] : null
  if (isSameCalendarDay(prevEnd, nextEnd)) return nextRange

  return [nextRange[0], toEndOfDay(nextEnd)]
}
